/*
 * ===============================================================================================================
 *                                Copyright 2023, Blue Yonder Group, Inc.
 *                                           All Rights Reserved
 *
 *                               THIS IS UNPUBLISHED PROPRIETARY SOURCE CODE OF
 *                                          BLUE YONDER GROUP, INC.
 *
 *
 *                         The copyright notice above does not evidence any actual
 *                                 or intended publication of such source code.
 *
 * ===============================================================================================================
 */
import { useSelector } from 'react-redux';
import { Button } from '@mui/material';
import FormDialog from '../Dialog/FormDialog';
import Loader from '../Loader';
import { selectLoader } from '../../store/loader/loaderSelector';
import { CANCEL_BTN_TEXT, ENTITIES } from './constants';
import { useStyles } from './styles';

interface PolicyDialogProps {
  children: React.ReactNode;
  handleClose: () => void;
  dialogTitle: string;
  saveLabel: string;
  isSaveDisabled?: boolean;
  handleSubmit: () => void;
  type?: any;
}

const PolicyDialog = ({
  children,
  handleClose,
  dialogTitle,
  saveLabel,
  isSaveDisabled = false,
  handleSubmit,
  type,
}: PolicyDialogProps) => {
  const displayLoader = useSelector(selectLoader);
  const { classes } = useStyles();

  return (
    <FormDialog
      openModal={true}
      handleClose={handleClose}
      dialogTitle={dialogTitle}
      dialogLoader={<Loader showLoader={displayLoader} customClasses={classes.customLoader} />}
      dialogAction1={
        <Button name="cancelBtn" onClick={handleClose} variant="outlined" color="primary">
          {CANCEL_BTN_TEXT}
        </Button>
      }
      dialogAction2={
        <Button name="saveBtn" disabled={isSaveDisabled} onClick={handleSubmit} variant="contained" color="primary">
          {saveLabel}
        </Button>
      }
      className={type?.key === ENTITIES ? classes.dialog : classes.dialogWithoutScroll}
    >
      {children}
    </FormDialog>
  );
};

export default PolicyDialog;
